// Added by Sejune Oh on 2019-09-23
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { DisplableDicomScpElementProps } from './DicomScpStore'
import { AssignedDataStorageElementProps } from '@/stores/mgmt/dataStorage'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetDicomScps = async (path: string = '') => {
  return await axios.get<GetQueryReturn<DisplableDicomScpElementProps>>(`/v1/mgmt/dicomscps?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetDicomScpProps extends DisplableDicomScpElementProps { }
export const reqGetDicomScp = async (id: string) => {
  return await axios.get<ResGetDicomScpProps>(`/v1/mgmt/dicomscps/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateDicomScpProps extends DisplableDicomScpElementProps { }
export const reqCreateDicomScp = async (gatewayElementProps: DisplableDicomScpElementProps) => {
  return await axios.post<ResCreateDicomScpProps>(`/v1/mgmt/dicomscps`, { ...gatewayElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteDicomScp = async (id: string) => {
  return await axios.delete(`/v1/mgmt/dicomscps/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateDicomScpProps extends DisplableDicomScpElementProps { }
export const reqUpdateDicomScp = async (id: string, gatewayElementProps: DisplableDicomScpElementProps) => {
  return await axios.put<ResUpdateDicomScpProps>(`/v1/mgmt/dicomscps/${id}`, {
    ...gatewayElementProps,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetAssignedDataStoragesToDicomScp extends AssignedDataStorageElementProps { }
export const reqGetAssignedDataStoragesToDicomScp = async (id: string) => {
  return await axios.get<GetQueryReturn<ResGetAssignedDataStoragesToDicomScp>>(
    `/v1/mgmt/dicomscps/${id}/assigned-datastorages`
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResAssignDataStoragesToDicomScp { }
export const reqAssignDataStoragesToDicomScp = async (id: string, fk_data_storage_ids: Array<string>) => {
  return await axios.put<ResAssignDataStoragesToDicomScp>(`/v1/mgmt/dicomscps/${id}/assigned-datastorages`, {
    id,
    fk_data_storage_ids,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResRestartAllDicomScpInTheGroup { }
export const reqRestartAllDicomScpInTheGroup = async (fk_group_id: string) => {
  await axios.post<ResRestartAllDicomScpInTheGroup>(`/v1/mgmt/dicomscps:restart`, { fk_group_id })
}
